import { camelizeKeys } from "humps";

type UploadFormDataArgs = {
  url: string;
  method: "POST" | "PUT";
  formData: FormData;
  onUploadProgress?: (percent: number) => void;
};

export const uploadFormData = <T>({
  formData,
  method,
  onUploadProgress,
  url
}: UploadFormDataArgs): Promise<T> =>
  new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.withCredentials = true;
    xhr.responseType = "json";
    xhr.setRequestHeader("Accept", "application/json");

    if (onUploadProgress) {
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable && event.total) {
          onUploadProgress(Math.round((event.loaded * 100) / event.total));
        }
      };
    }

    xhr.onload = () => {
      const body = (xhr.response ?? {}) as Record<string, unknown>;

      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(camelizeKeys(body) as T);
      } else {
        reject({ ...body, status: xhr.status });
      }
    };

    xhr.onerror = () => reject({ status: xhr.status || 0 });

    xhr.send(formData);
  });
